module.exports = __webpack_public_path__ + "static/media/drafting-compass.313e553c.svg";